import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore/lite';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../firebase.config';
import LoadingAdmin from '../extra/LoadingAdmin';

function AllProducts() {

    //Firestore Fetch Data
    const prolist = collection(db, "products" )
    const [allProducts,setAllProducts] = useState([])
    useEffect(()=>{
        async function fetchFirestore() {
       
        const data = await getDocs(prolist);
        const result = data.docs.map((doc)=>({...doc.data(),id: doc.id}))
            setAllProducts(result)
            console.log(result)
        
        return 0;
        
      }
      fetchFirestore()
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[])


      //Delete Function
      const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
      const [delId,setDelId] = useState()
      const proDelId = delId ? delId : "0"
      const  fordel = doc(db, "products", proDelId)

      function handleDelete() {
        setShowDeleteConfirmation(true);
        //devLog
        console.log(delId);
      }
      
      function handleCancel() {
        setShowDeleteConfirmation(false);
      }

      function handleConfirmDelete() {

        async function del() {
           
            
          await deleteDoc(fordel)

          console.log('Deleted :')
          return fordel;
        }
        del()
        setShowDeleteConfirmation(false);
      }

  return (
    <div>
      {allProducts.length!==0?
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="p-4">
                <div className="flex items-center">
                  0
                </div>
              </th>
              <th scope="col" className="px-6 py-3">
                Product name
              </th>
              <th scope="col" className="px-6 py-3">
                Category
              </th>

              <th scope="col" className="px-6 py-3">
                Available
              </th>
              <th scope="col" className="px-6 py-3">
                Price
              </th>

              <th scope="col" className="px-6 py-3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {
                allProducts.map((item,index)=>(
                    
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={index}>
              <td className="w-4 p-4">
                <div className="flex items-center">
                  <p>{index+1}</p>
                  {/* <input id="checkbox-table-search-1" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label for="checkbox-table-search-1" className="sr-only">checkbox</label> */}
                </div>
              </td>
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
              >
                {item.title.substring(0,35)}
              </th>
              
              <td className="px-6 py-4">{item.category}</td>

              <td className="px-6 py-4">{item.unavailable? "No" :"Yes"}</td>
              <td className="px-6 py-4 font-semibold">{item.price}<span className="font-normal">&pi;</span> </td>

              <td className="flex items-center px-6 py-4 space-x-3">
                 <Link to={`/admin/edit-product/${item.id}`} 
                  className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                >
                  Edit
                </Link>
                <p
                  onClick={()=> setDelId(item.id) & handleDelete() }
                  className="font-medium text-red-600 dark:text-red-500 hover:underline cursor-pointer"
                >
                  Remove
                </p>
                {showDeleteConfirmation && (
                  <div className="fixed bg-white bg-opacity-10 flex justify-center items-center top-0 left-0 right-0 bottom-0">
                    <div className=" bg-slate-800 p-12 border-slate-900 rounded-xl ">
                    <p>Are you sure you want to delete this item?</p>
                      <div className="justify-between text-center font-bold tracking-wider flex pt-5 px-3">
                      <button className="text-blue-500 " onClick={handleCancel}>Cancel</button>
                      <button className="text-red-500 opacity-80" onClick={handleConfirmDelete}>Delete</button>
                      </div>
                    </div>
                  </div>
                )} {/**/}
              </td>
            </tr>
                ))
                }
          </tbody>
        </table>
      </div>
           : <LoadingAdmin/> }
    </div>
  )
}

export default AllProducts